import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Alert } from 'antd';

const RegisterForm = ({
  handleSubmit,
  handleChange,
  name,
  username,
  email,
  phone,
  password,
  apiResponse,
  loading,
}) => {
  const [toggle, setToggle] = useState(false);
  
  const handleToggle = (e) => {
    setToggle((prev) => !prev);
  };

  return (
    <div className='register-form-card'>
      <div className='card-header'>
        <h2>Criar Conta</h2>
      </div>
      <div className='card-body'>
        {apiResponse && (
          <div className='mb-4'>
            <Alert message={apiResponse} type='error' showIcon />
          </div>
        )}
        <form onSubmit={handleSubmit}>
          <div className='form-group'>
            <label className='form-label'>Seu Nome</label>
            <input
              type='text'
              className='form-control'
              placeholder='Escreva seu nome completo'
              value={name}
              onChange={handleChange('name')}
            />
          </div>

          <div className='form-group'>
            <label className='form-label'>Nome de Usuário</label>
            <input
              type='text'
              className='form-control'
              placeholder='Escolha um nome de usuário'
              value={username}
              onChange={handleChange('username')}
            />
          </div>

          <div className='form-group'>
            <label className='form-label'>E-mail</label>
            <input
              type='email'
              className='form-control'
              placeholder='Escreva seu e-mail'
              value={email}
              onChange={handleChange('email')}
            />
          </div>

          <div className='form-group'>
            <label className='form-label'>Telefone</label>
            <input
              type='tel'
              className='form-control'
              placeholder='Escreva seu telefone'
              value={phone}
              onChange={handleChange('phone')}
            />
          </div>

          <div className='form-group'>
            <label className='form-label'>Senha</label>
            <div className='password-wrapper'>
              <input
                type={toggle ? 'text' : 'password'}
                className='form-control'
                placeholder='Crie uma senha segura'
                value={password}
                onChange={handleChange('password')}
              />
              {toggle ? (
                <i className='fas fa-eye togglePassword' onClick={handleToggle}></i>
              ) : (
                <i
                  className='fas fa-eye-slash togglePassword'
                  onClick={handleToggle}
                ></i>
              )}
            </div>
          </div>

          <Button
            type='primary'
            size='large'
            htmlType='submit'
            disabled={loading}
          >
            {loading ? 'Carregando...' : 'Cadastrar'}
          </Button>

          <div className='login-link-container'>
            <p>
              Já tem uma conta?
              <Link to='/login' className='text-decoration-none'>
                Entrar agora
              </Link>
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RegisterForm;
